/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {ColorPicker} from 'primereact/colorpicker';
import useInputValidation from './useInputValidation';

const FormColorPicker = ({value, parent, onChange, field, formDisabled, disabled, required, validators, onValidate}) => {
    const {validationErrorCss} = useInputValidation({
        value,
        field,
        required,
        validators,
        onValidate,
        parent
    });

    return (
        <>
            <ColorPicker
                id={field}
                style={{width: '100%'}}
                className={`${validationErrorCss}`}
                onChange={(event) => onChange(event.value)}
                value={value ?? ''}
                disabled={disabled ?? formDisabled}
            />
        </>
    );
};

export default FormColorPicker;